import React, {useRef} from 'react';
import DownloadTrayIcon from "../basic/DownloadTrayIcon";
import DownloadManagerModal from "../basic/DownloadManagerModal";
import MobileNavDrawer from "../navigation/MobileNavDrawer";
import MobileBoxesDrawer from "../basic/MobileBoxesDrawer";
import TwoLevelDropdown from "../basic/TwoLevelDropdown/TwoLevelDropdown";

const Header = ({
                    selectionOptions = [],
                    selectedThreadIds = [],
    selectedUids = [],
                    selectionChangeEventHandler = null,
                    showMobileSelectionDropDown = false,
                    setShowDownloadModal,
                    showDownloadModal,
                    isDownloadModalNeeded = false,
                    onSelectFolder,
                    folders = [],
                    currentMbox = null,
                    redirectToFoldersPage
                }) => {

    console.log("I am here")
    console.log(selectionOptions)

    const mobileNavRef = useRef();

    const mobileBoxesRef = useRef()

    const handleMenuClick = () => {
        mobileNavRef.current?.openDrawer();
    };

    const handleFoldersClick = () => {
        mobileBoxesRef.current?.openDrawer()
    }

    return (
        <>
            <div
                className="flex items-center justify-between border border-gray-400 h-[5vh] px-4"
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    height: '5vh',
                    border: '1px solid grey',
                    padding: '0 1rem'
                }}
            >
                {/* Brand title - only visible on desktop */}
                <h1 className="d-none d-md-block" style={{fontSize: '24px', margin: 0}}>
                    Privmail
                </h1>

                {/* Mobile: folder dropdown + menu */}
                <div className="d-flex align-items-center d-md-none gap-2">

                    <i className="fa-solid fa-bars"
                       style={{fontSize: '20px', cursor: 'pointer', paddingRight: "20px"}}
                       onClick={handleMenuClick}
                       title="Open Menu"
                    ></i>
                    {folders.length > 0 && (<i className="fa-solid fa-folder"
                                               style={{fontSize: '20px', cursor: 'pointer', paddingRight: "20px"}}
                                               onClick={handleFoldersClick}
                                               title="Open Menu"
                    ></i>)}
                    {(selectionOptions.length > 0 && (selectedUids.length > 0 || selectedThreadIds.length > 0)) && (
                        <TwoLevelDropdown menuItems={selectionOptions} onSelect={selectionChangeEventHandler}/>)}
                </div>

                {/* Download modal */}
                {isDownloadModalNeeded && (
                    <div>
                        <DownloadTrayIcon onClick={() => setShowDownloadModal(true)}/>
                        <DownloadManagerModal
                            visible={showDownloadModal}
                            onClose={() => setShowDownloadModal(false)}
                        />
                    </div>
                )}
            </div>

            {/* Mobile navigation drawer (hidden on desktop) */}
            <MobileNavDrawer
                ref={mobileNavRef}
            />

            <MobileBoxesDrawer
                ref={mobileBoxesRef}
                boxes={folders}
                setCurrentBox={onSelectFolder}
                currentBox={currentMbox}
                redirectToFoldersPage={redirectToFoldersPage}
            />

        </>
    );
};

export default Header;
